<app-info-modal title="Importante">
    <div class="eu-display_flex eu-column">
        <div class="eu-display_flex eu-column offer-modal-body p-4 mb-2">
            <div class="mb-4">
                <span class="emd-text _size_section _color_default mb-4">
                    PARABÉNS, falta pouco para contratar a oferta Modo Adesão!
                </span>

                <br />
                <br />

                <p class="emd-text _size_section _color_default">
                    As máquinas serão solicitadas conforme o pagamento da taxa de adesão for feito.
                    O <span class="emd-text _type_bold">Link de Pagamento</span> foi enviado para o
                    e-mail registrado em contato administrativo.
                </p>
                <br />
                <p class="emd-text _size_section _color_default">
                    No <span>botão Proposta</span> disponibilizamos um PDF consolidando a oferta
                    contratada pelo cliente para você enviar por WhatsApp ou E-mail.
                </p>
            </div>
            <div class="mb-2">
                <div class="p-4" style="background-color: #cefde5; border-radius: 8px">
                    <div class="d-flex eu-justify_space-between pt-4 pb-4 mb-2 titles">
                        <h2 class="_type_bold emd-text _size_subpage">Criação de Cadastro</h2>
                        <h2 class="_type_bold emd-text _size_subpage">
                            Pagamento de Taxa de Adesão
                        </h2>
                        <h2 class="_type_bold emd-text _size_subpage">Entrega de Terminais</h2>
                    </div>
                    <div class="d-flex eu-justify_space-between pr-4 pl-4 mb-4">
                        <div class="progress-container">
                            <div class="progress-bar"></div>
                            <div class="progress-ball start"></div>
                            <div class="progress-ball-check-mark middle">
                                <img width="25" height="25" src="/assets/icons/check-mark.svg" />
                            </div>
                            <div class="progress-ball end"></div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center pr-4 pl-4 mt-4">
                        <span class="_color_default">Você está aqui</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="eu-flex eu-justify_space-between offer-modal-footer p-2">
            <button type="button" class="emd-btn _size_big _color_primary" (click)="openProposal()">
                Proposta
            </button>
            <button type="button" class="emd-btn _size_big _color_primary" (click)="closeModal()">
                Fechar
            </button>
        </div>
    </div>
</app-info-modal>
